var GAVisitor = require("@generalassembly/ga-visitor-js");
var ClickTracker = require("./clickTracker");
var ContextRegistry = require("./contextRegistry");

(function() {
  var GASnowplowJS = function(options) {
    options = options || {};
    this.appId = options.appId || null;
    this.debug = options.debug || false;
    this.globalContext = new ContextRegistry();
    if (options.errorTracking === undefined) {
      this.errorTracking = true;
    } else {
      this.errorTracking = !!options.errorTracking;
    }
    if (options.linkClickTracking === undefined) {
      this.linkClickTracking = true;
    } else {
      this.linkClickTracking = !!options.linkClickTracking;
    }
    if (options.formTracking === undefined) {
      this.formTracking = false;
    } else {
      this.formTracking = !!options.formTracking;
    }
    if (options.clickTracking) {
      this.clickTracker = new ClickTracker();
    }
    if (options.webPageTracking === undefined) {
      this.webPageTracking = true;
    } else {
      this.webPageTracking = !!options.webPageTracking;
    }
    if (options.performanceTimingTracking === undefined) {
      this.performanceTimingTracking = true;
    } else {
      this.performanceTimingTracking = !!options.performanceTimingTracking;
    }

    this.visitorCookieName = options.visitorCookieName || '_general_assembly_visitor_id';
    this.userCookieName = options.userCookieName || 'sso_provider_session_production';
    this.cookieLifetime = options.cookieLifetime || 86400 * 180;
    this.spCollector = options.spCollector || '';
    this.optimizelyXSummary = !!(window.optimizely && window.optimizely.get);
    this.formTrackingFormBlacklist = options.formTrackingFormBlacklist || ['do-not-track'];
    this.formTrackingFieldBlacklist = options.formTrackingFieldBlacklist || [];

    this.trackerVersion = options.trackerVersion || '2.8.2';
    this.trackerName = options.trackerName || ('cf-hosted-v' + this.trackerVersion);

    if (this.visitorCookieName) {
      var visitor = new GAVisitor(this.visitorCookieName);
      if (visitor && visitor.id) {
        this.globalContext.setContext("visitor", {
          schema: "iglu:co.ga/visitor_id/jsonschema/1-0-0",
          data: {
            visitor_id: visitor.id,
          },
        });
      }
    }
  }

  GASnowplowJS.prototype.log = function(message) {
    if (this.debug) console.log('GASnowplowJS: ' + message);
  }

  GASnowplowJS.prototype.init = function() {
    if (!this.appId || !this.spCollector) return;
    this.log('appId=' + this.appId);

    (function(p, l, o, w, i, n, g) {
      if (!p[i]) {
        p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
        p.GlobalSnowplowNamespace.push(i);
        p[i] = function() {
          (p[i].q = p[i].q || []).push(arguments);
        };
        p[i].q = p[i].q || [];
        n = l.createElement(o);
        g = l.getElementsByTagName(o)[0];
        n.async = 1;
        n.id = 'ga-snowplow-script';
        n.src = w;
        g.parentNode.insertBefore(n, g);
      }
    }(window, document, 'script', '//d1fc8wv8zag5ca.cloudfront.net/' + this.trackerVersion + '/sp.js', 'GAplow'));

    try {
      this.createFullTracker();
    } catch(err) {
      this.createMinimalTracker();
      throw err;
    }
  }

  GASnowplowJS.prototype.createTracker = function(contexts) {
    window.GAplow('newTracker', this.trackerName, this.spCollector, {
      appId: this.appId,
      platform: 'web',
      cookieDomain: 'generalassemb.ly',
      cookieName: 'sp',
      encodeBase64: false,
      respectDoNotTrack: false,
      userFingerprint: true,
      userFingerprintSeed: 6485926835,
      pageUnloadTimer: 0,
      forceSecureTracker: false,
      stateStorageStrategy: 'cookie',
      post: true,
      bufferSize: 1,
      maxPostBytes: 45000,
      cookieLifetime: this.cookieLifetime,
      contexts: contexts
    })

    if (this.errorTracking) window.GAplow('enableErrorTracking');

    if (this.linkClickTracking) window.GAplow('enableLinkClickTracking');
    if (this.clickTracker) this.clickTracker.register(this.trackClickEvent.bind(this));
    if (this.formTracking) window.GAplow('enableFormTracking', {
      forms: {
        blacklist: this.formTrackingFormBlacklist
      },
      fields: {
        blacklist: this.formTrackingFieldBlacklist
      }
    });
    if (this.userCookieName) window.GAplow('setUserIdFromCookie', this.userCookieName);

    window.GAplow('enableActivityTracking', 30, 30);
    window.GAplow('trackPageView', null, null, this.pageViewCustomContexts)
  }

  GASnowplowJS.prototype.createMinimalTracker = function() {
    this.createTracker({
      webPage: this.webPageTracking,
      performanceTiming: this.performanceTimingTracking,
      gaCookies: true
    });
  }

  GASnowplowJS.prototype.createFullTracker = function() {
    this.createTracker({
      webPage: this.webPageTracking,
      performanceTiming: this.performanceTimingTracking,
      gaCookies: true,
      optimizelyXSummary: this.optimizelyXSummary,
      optimizelySummary: true
    });
  }

  GASnowplowJS.prototype.setContext = function(type, data) {
    this.log('setContext, type: ' + type + ', data: ' + JSON.stringify(data));
    this.clickTracker.setContext(type, data)
  }

  GASnowplowJS.prototype.clearContext = function(type) {
    this.log('clearContext, type: ' + type);
    this.clickTracker.clearContext(type)
  }

  GASnowplowJS.prototype.setGlobalContext = function(type, data) {
    this.log("setGlobalContext, type: " + type + ", data: " + JSON.stringify(data));
    this.globalContext.setContext(type, data);
  };

  GASnowplowJS.prototype.clearGlobalContext = function(type) {
    this.log("clearGlobalContext, type: " + type);
    this.globalContext.clearContext(type);
  };

  GASnowplowJS.prototype.trackClickEvent = function(payload) {
    var schema = 'iglu:co.ga.lms/click_tracked/jsonschema/1-0-0';

    this.log('trackClickEvent, schema: ' + schema + ' data: ' + JSON.stringify(payload));
    window.GAplow('trackSelfDescribingEvent', {
      schema: schema,
      data: payload.data,
    }, payload.contexts.concat(this.globalContext.list()));
  }

  GASnowplowJS.prototype.trackSelfDescribingEvent = function(schema, data) {
    this.log('trackSelfDescribingEvent, schema: ' + schema + ' data: ' + JSON.stringify(data));
    window.GAplow('trackSelfDescribingEvent', {
      schema: schema,
      data: data,
    }, this.globalContext.list());
  }

  GASnowplowJS.prototype.trackStructEvent = function(category, action, label, property, value, additionalContexts) {
    this.log('trackStructEvent' +
      ', category: ' + category +
      ', action: ' + action +
      ', label: ' + label +
      ', property: ' + property +
      ', value: ' + value +
      ', additionalContexts: ' + additionalContexts
    );
    var contexts = this.globalContext.list()
                    .concat(additionalContexts)
                    .filter(function(item) { return item });
    window.GAplow('trackStructEvent', category, action, label, property, value, contexts);
  }

  // Retain backwards compatibility
  var initGASnowplow = function(appId, debug, visitorCookieName, userCookieName, spCollector) {
    window.gaSnowplowJS = new GASnowplowJS({
      appId: appId,
      debug: debug,
      visitorCookieName: visitorCookieName,
      userCookieName: userCookieName,
      spCollector: spCollector,
    })
    window.gaSnowplowJS.init()
  }

  if (typeof(module) !== 'undefined') {
    module.exports = {
      GASnowplowJS: GASnowplowJS,
      initGASnowplow: initGASnowplow,
    }
  }

  if (typeof(window) !== 'undefined') {
    window.GASnowplowJS = GASnowplowJS;
    window.initGASnowplow = initGASnowplow;
  }
})();
